module.exports = __webpack_public_path__ + "img/tv.829fb9d8.svg";